module.exports = __webpack_public_path__ + "assets/img/upgrade3.037ae109.svg";